(() => {
	const instaFastVersion = 5;
	const resultDiv = document.querySelector(".instafast-estimated-arrival-date");
	const soonerLabel = document.querySelector("label.instafast-sooner");
	const soonerDd = document.querySelector("dl.instafast-sooner > dd");
	function instaFastClear(resultInnerText) {
		/* Remove the instaFast results from the DOM.
		 */
		document
			.querySelectorAll(".instafast-estimated-arrival-date")
			.forEach((resultDiv) => (resultDiv.innerText = resultInnerText));
		document
			.querySelectorAll(".instafast-estimated-arrival-day")
			.forEach((resultDiv) => (resultDiv.innerText = resultInnerText));
		if (soonerLabel) {
			soonerLabel.style.display = "none";
			document.querySelector("#instafast-sooner-toggle").checked = false;
			soonerDd.innerText = "";
		}
	}
	function formatDateOnlyString(dateString) {
		// Date-only strings are treated as UTC, and DST +/- 1hr should not be a problem
		const formatted = new Date(`${dateString}T12:00:00-07:00`).toLocaleString(undefined, {
			weekday: "short",
			month: "short",
			day: "numeric"
		});
		if (formatted == "Invalid Date") {
			return "";
		}
		return formatted.toUpperCase();
	}
	async function instaFastUpdate(event) {
		/* Update the DOM to reflect the instaFast results. Should be called after page loads
		 * including AJAX product fetches, and after instaFastFetch.
		 */
		// TODO: consider using Window.storage event? (Note: This won't work on the same page that is making the changes — it is really a way for other pages on the domain using the storage to sync any changes that are made.)
		let instaFastInfo = JSON.parse(localStorage.getItem("instaFast"));
		let destination_zip;
		// if event: form was submitted to apply zip code, though zip may not have changed
		if (event) {
			destination_zip = (event.target.querySelector(".zip-input").value ?? "").trim();
		}
		// else: Page load or old estimate expired
		else if (instaFastInfo) {
			destination_zip = instaFastInfo.zip;
		} else if (document.querySelector(".instafast-zip").innerText) {
			// Use currently displayed zip, which defaults to customer default
			destination_zip = document.querySelector(".instafast-zip").innerText;
			// } else if (navigator.geolocation) {
			// 	navigator.geolocation.getCurrentPosition(position => {
			// 		destination_zip = position.address?.postalCode;
			// 	});
			// }
		} else {
			try {
				// Get ZIP from IP address
				const r = await fetch("https://geo-rcpefdugtq-wl.a.run.app/");
				const zip = await r.text();
				if (/^\d{5}$/.test(zip.trim())) {
					// console.debug(`GEO ZIP: ${zip}`)
					destination_zip = zip;
				}
			} catch {}
		}
		if (!destination_zip) {
			destination_zip = "90021";
		}

		displayZip(destination_zip);
		// console.debug({ destination_zip });
		// TODO: Validate zip
		if (
			event ||
			!instaFastInfo ||
			instaFastInfo.zip != destination_zip ||
			new Date(instaFastInfo.expires) <= new Date()
		) {
			// need to fetch new instaFast info
			instaFastClear("⏳");
			// instaFastFetch will set localStorage with new info
			await instaFastFetch(destination_zip);
			instaFastInfo = JSON.parse(localStorage.getItem("instaFast"));
		}
		if (instaFastInfo?.errors) {
			instaFastClear(instaFastInfo.errors);
			return;
		}
		if (!instaFastInfo) {
			instaFastClear("❗️");
			return;
		}
		const { estimates, zip } = instaFastInfo;
		let expires = new Date(instaFastInfo.expires);
		let expiryTimeoutDelay = expires - new Date();
		console.debug("InstaFast info expires in", expiryTimeoutDelay);
		setTimeout(instaFastUpdate, expiryTimeoutDelay);
		// console.debug({ estimates });
		const { fdx2day, ground } = estimates;
		let displayedShip;
		let rdit = "";
		if (fdx2day?.date && ground?.date) {
			displayedShip = fdx2day.date < ground.date ? fdx2day.date : ground.date;
			rdit = displayedShip;
		} else if (fdx2day?.date) {
			displayedShip = fdx2day.date;
			rdit = displayedShip;
		} else if (ground?.date) {
			displayedShip = ground.date;
			rdit = displayedShip;
		} else {
			rdit = "❗️";
		}
		const estimatedDate = new Date(`${rdit}T12:00:00-07:00`); // Date-only strings are treated as UTC, and DST +/- 1hr should not be a problem
		let formatted = rdit;
		let estimatedDay = rdit;
		if (estimatedDate != "Invalid Date") {
			formatted = estimatedDate
				.toLocaleString(undefined, {
					weekday: "short",
					month: "short",
					day: "numeric"
				})
				.toUpperCase();
			estimatedDay = estimatedDate
				.toLocaleString(undefined, {
					weekday: "long",
					month: "numeric",
					day: "numeric"
				})
				.replace(",", "");
		}
		document
			.querySelectorAll(".instafast-estimated-arrival-date")
			.forEach((resultDiv) => (resultDiv.innerText = formatted));
		document
			.querySelectorAll(".instafast-estimated-arrival-day")
			.forEach((resultDiv) => (resultDiv.innerText = estimatedDay));
		if (displayedShip && ground?.date) {
			let innerHTML = "";
			const usedSoonerDates = [];
			Object.values(estimates)
				.filter((ife) => ife.code !== "PSPM")
				.sort((a, b) => a.date.localeCompare(b.date))
				.forEach(({ date, description }) => {
					if (date < displayedShip && !usedSoonerDates.includes(date)) {
						usedSoonerDates.push(date);
						innerHTML += `<strong>${formatDateOnlyString(date)}</strong> – ${description}<br />`;
					}
				});
			if (innerHTML && soonerLabel) {
				soonerDd.innerHTML = innerHTML;
				soonerLabel.style.display = "inline";
			}
		}
	}

	async function instaFastFetch(destination_zip) {
		/* Look up estimated delivery dates for a destination ZIP code, and store result in localStorage.
		 * To prevent excessive API calls, only call this function when the user changes the ZIP code,
		 * there is no result already in localStorage, or the stored result has expired.
		 *
		 * You should call instaFastUpdate to update the DOM with the new values.
		 */
		try {
			const response = await fetch("https://us-central1-ibdatabase.cloudfunctions.net/instafast", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ destination_zip })
			});
			const data = await response.json();
			console.debug("instaFast data", data);
			if (data.errors) {
				localStorage.setItem("instaFast", JSON.stringify(data));
				resultDiv.innerText = data.errors;
			} else {
				let estimates = {};
				const zip = data.zip;
				const expires = data.expires;
				if (data.ups) {
					const ups = data.ups;
					const ground = ups.services
						?.filter((ss) => ss.serviceLevel === "GND")
						?.map((ss) => ({
							code: ss.serviceLevel,
							description: ss.serviceLevelDescription,
							date: ss.deliveryDate
						}))[0]; // UPS Ground
					const threeDS = ups.services
						?.filter((ss) => ss.serviceLevel === "3DS")
						?.map((ss) => ({
							code: ss.serviceLevel,
							description: ss.serviceLevelDescription,
							date: ss.deliveryDate
						}))[0]; // UPS 3 Day Select
					const twoDA = ups.services
						?.filter((ss) => ss.serviceLevel === "2DA")
						?.map((ss) => ({
							code: ss.serviceLevel,
							description: ss.serviceLevelDescription,
							date: ss.deliveryDate
						}))[0]; // UPS 2nd Day Air
					const twoDAS = ups.services
						?.filter((ss) => ss.serviceLevel === "2DAS")
						?.map((ss) => ({
							code: ss.serviceLevel,
							description: ss.serviceLevelDescription,
							date: ss.deliveryDate
						}))[0]; // UPS 2nd Day Air (Saturday Delivery Available)
					const oneDA = ups.services
						?.filter((ss) => ss.serviceLevel === "1DA")
						?.map((ss) => ({
							code: ss.serviceLevel,
							description: ss.serviceLevelDescription,
							date: ss.deliveryDate
						}))[0]; // UPS Next Day Air
					const oneDP = ups.services
						?.filter((ss) => ss.serviceLevel === "1DP")
						?.map((ss) => ({
							code: ss.serviceLevel,
							description: ss.serviceLevelDescription,
							date: ss.deliveryDate
						}))[0]; // UPS Next Day Air Saver
					const oneDM = ups.services
						?.filter((ss) => ss.serviceLevel === "1DM")
						?.map((ss) => ({
							code: ss.serviceLevel,
							description: ss.serviceLevelDescription,
							date: ss.deliveryDate
						}))[0]; // UPS Next Day Air Early
					estimates = { ...estimates, ground, threeDS, twoDA, twoDAS, oneDA, oneDP, oneDM };
				}
				if (data.fedex) {
					// data.fedex will only inlcude 2-Day estimates. If Saturday delivery is available, data.fedex will have multiple entries.
					// Sort and choose the earliest commit date.
					const fdx2day = data.fedex.toSorted((a, b) =>
						a.commit.dateDetail.dayFormat.localeCompare(b.commit.dateDetail.dayFormat)
					)[0];
					estimates = { ...estimates, fdx2day: {
						code: fdx2day.serviceType,
						description: fdx2day.serviceName,
						date: fdx2day.commit.dateDetail.dayFormat.split('T')[0]
					} };
				}
				localStorage.setItem(
					"instaFast",
					JSON.stringify({ estimates, zip, expires, version: instaFastVersion })
				);
				return estimates;
			}
		} catch (e) {
			console.error(e);
			localStorage.clear("instaFast");
			resultDiv.innerText = "❗️";
		}
	}

	function toggleForm(event) {
		/* Show/hide the dialog to change ZIP code.
		 */
		const dialog = document.querySelector("dialog.instafast");
		if (dialog.open) {
			dialog.close();
		} else {
			dialog.show();
			dialog.querySelector(".zip-input").select();
		}
	}

	function displayZip(zip) {
		/* Update DOM to show the ZIP code being used to calculate delivery date. If zip is not provided,
		 * if zip is not provided, look if up from last call to instaFastFetch in localStorage.
		 */
		if (!zip) {
			zip = JSON.parse(localStorage.getItem("instaFast"))?.zip;
		}
		if (zip) {
			document.querySelectorAll(".zip-input").forEach((el) => (el.value = zip));
			document.querySelectorAll(".instafast-zip").forEach((el) => (el.innerText = zip));
		}
	}

	document.querySelector("#instafast-zip-parent").addEventListener("click", toggleForm);
	document.querySelectorAll(".betaship-container").forEach((el) =>
		el.addEventListener("submit", (event) => {
			event.preventDefault();
			document.querySelector("dialog.instafast").close();
			instaFastUpdate(event); // any need to await?
		})
	);
	// document.querySelector('.instafast-details').addEventListener('click', async (event) => {
	// 	if (getComputedStyle(soonerDd).display == 'none') {
	// 		soonerDd.style.display = 'initial';
	// 	} else {
	// 		soonerDd.style.display = 'none';
	// 	}
	// });
	// document.addEventListener('readystatechange', (event) => {
	// 	console.debug(event);
	// })
	function mutationCallback(mutationList, observer) {
		observer.disconnect();
		instaFastUpdate().finally(() => {
			document.querySelectorAll("div.container").forEach((el) => observer.observe(el, { childList: true }));
		});
	}
	function init() {
		const instaFast = JSON.parse(localStorage.getItem("instaFast"));
		if (instaFast) {
			if (instaFast.version !== instaFastVersion || !instaFast.estimates?.ground || !instaFast.estimates?.fdx2day) {
				localStorage.clear("instaFast");
			}
		}
		instaFastUpdate();
		// TODO: Assuming -08:00 for pacific time zone, but should use -07:00 depending on DST.
		// new Date("2024-01-01T12:00:00-08:00")
		// Just make sure you use a date when Standard/Daylight is in effect
		document.querySelectorAll(".instafast-local-cutoff").forEach(
			(el) =>
				(el.innerText = new Date("2025-12-01T13:00:00-08:00")
					.toLocaleString(undefined, {
						hour: "numeric",
						timeZoneName: "longGeneric"
					})
					.replace(" AM ", "am ")
					.replace(" PM ", "pm ")
					.replace(" Time", ""))
		);
		// TODO: If site pagination uses ajax, need to populate GET IT date on loaded products.
		const observer = new MutationObserver(mutationCallback);
		document.querySelectorAll("div.container").forEach((el) => observer.observe(el, { childList: true }));
		// observer.observe(document.body, {subtree: true, childList: true})
	}
	if (document.readyState === "loading") {
		addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
